<template>
    <div
        :id="parentContainerId+'-'+stringToClass(relationTag.name)"
        :class="{
          tag: true,
          [stringToClass(relationTag.name)] :relationTag.name,
          [relationTag.category]: relationTag.category,
          'tag-with-sentiment': relationTag.show_sentiment,
          ['tag-parent-'+relationTag.parent]: relationTag.parent,
          'tag-with-delete': !isOrganizationTag,
        }"
        :tag-data="stringToClass(relationTag.name)"
        :tag-grouping="relationTag.category"
        :style="{background: relationTag.color}" >

      <span>{{ relationTagName }}</span>
      <div class="sentiment-wrapper" v-if="showScoringSystem && relationTag.show_sentiment">
        <span class="sentiment positive align-center"
            v-on:click="(e) => onRelationSentimentClick(e, true)">
          {{ getTagScore(relationTag, true) }}
        </span>
        <span class="sentiment negative align-center"
            v-on:click="(e) => onRelationSentimentClick(e, false)">
          {{ getTagScore(relationTag, false) }}
        </span>
      </div>
      <div class="delete-tag fas fa-times"
           v-if="!isOrganizationTag"
           v-on:click="(e) => deleteRelationMentionTag(e, tag)" />
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import _ from 'lodash';

  import editor from '../../helpers/editor';
  import array from '../../helpers/array';
  import { TAG_CATEGORY } from '../../config/const';
  import SHORTCUT from '../../config/shortcut-keys';

  export default {
    props: {
      parentContainerId: String,
      tag: Object,
      relationTag: Object,
      activeOrganization: String,
      showScoringSystem: {
        type: Boolean,
        required: true
      },
      keysPressed: {
        type: Array,
        required: true
      },
      isActive: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      ...mapState('tags', [
        'tags'
      ]),
      isOrganizationTag () {
        return this.relationTag.category === TAG_CATEGORY.ORGANIZATION;
      },
      relationTagName () {
        let name = this.relationTag.name;
        if (this.relationTag.hasOwnProperty('active') && !this.relationTag.active) {
          name = name + " (Inactive)";
        }
        return name;
      }
    },
    methods: {
      stringToClass(string) {
        return editor.stringToClass(string);
      },
      onRelationSentimentClick(e, isPositive) {
        e.preventDefault();
        e.stopPropagation();
        let reducePoints = e.shiftKey ? true : false;
        //log mentions before modification of sentiment
        this.$emit('recordAction', this.tag);
        
        this.$emit('updateMentionSentiment', {tag: this.tag, isPositive: isPositive, isRelation: true, isReduce: reducePoints});
      },
      onRelationTagArrowClick(e, tag) {
        e.preventDefault();
        e.stopPropagation();

        const clickPosition = {
          xCoordinate: e.clientX,
          yCoordinate: e.clientY
        };

        this.$emit('showRelationTagMenu', {tag: tag, clickPosition: clickPosition});
      },
      getTagScore (tag, positive) {
        return editor.getTagScore(tag, positive);
      },
      deleteRelationMentionTag(e, tag) {
        e.preventDefault();
        e.stopPropagation();

        if(!this.isActive) return

        //log mentions before removing tag
        this.$emit('recordAction', tag);
        this.$emit('deleteRelationMentionTag', tag);
      }
    }
  }
</script>